<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Users"
                    />
                    <!-- End Title -->
                </div>
            </div>

            <app-box :loading="loading" :initial="loading">
                <app-field-select
                    :required="true"
                    label="Group"
                    :items="groups"
                    v-model="fields.group_id"
                    preselect="&mdash; Please select &mdash;"
                    :error="errors.group_id"
                />

                <app-field-text 
                    :required="true"
                    label="Name" 
                    v-model="fields.name" 
                    :error="errors.name"
                />

                <app-field-text 
                    :required="true"
                    label="Email" 
                    v-model="fields.email" 
                    :error="errors.email"
                />

                <app-field-text 
                    :required="false"
                    label="New Password" 
                    v-model="fields.new_password" 
                    :error="errors.new_password"
                />

                <div slot="footer">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>

                    <app-button element="a" class="btn  btn--secondary  btn--secondary--sml ml-4" @click="$router.push({ name: 'users.home' })">
                        Cancel
                    </app-button>
                </div>
            </app-box>
        </app-content>

        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';

    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';

    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';
    import Permissions from '@/components/Permissions';
    import TextField from '@/components/fields/inputs/Text';
    import SelectField from '@/components/fields/inputs/Select';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'users.edit',

        props: {
            id: {
                type: String,
                required: true
            }
        },

        data: () => ({
            loading: true,
            groups: {},
            fields: {
                group_id: '',
                name: '',
                email: '',
                new_password: ''
            },
            errors: {}
        }),

        mixins: [ ValidationErrors ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
            'app-field-text': TextField,
            'app-field-select': SelectField,
            'app-permissions': Permissions
        },

        mounted() {
            this.get().then(response => {
                return this.setup();
            }).then(response => {
                this.loading = false;
            });
        },

        methods: {
            setup() {
                return Api.request('get', `users/edit/${this.id}`).then(({ data }) => {
                    for(let key in this.fields) {
                        if(typeof data.user[key] != 'undefined') {
                            this.fields[key] = data.user[key];
                        }
                    }
                });
            },

            get() {
                return Api.request('get', 'users/groups').then(response => {
                    if(typeof response.data.groups !== 'undefined') {
                        this.groups = response.data.groups;
                    }
                });
            },

            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', `users/update/${this.id}`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, { 
                            type: "success", 
                            position: "bottom-right", 
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'users.home'
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/users/Edit.vue